import React from 'react';
import { Edit } from 'react-admin';
import PositionRateSettingsForm from '../shared/position-rate-settings-form/PositionRateSettingsForm';
import { getTransform } from '../rateSettingsTransform';

const MarketLocationTypePositionRateSettingEdit = () => (
  <Edit
    mutationMode="pessimistic"
    transform={getTransform(
      ['market_id', 'location_type_id'],
      'market_location_type_position_rate_setting',
    )}
  >
    <PositionRateSettingsForm settingsField="market_location_type_position_rate_setting" />
  </Edit>
);

export default MarketLocationTypePositionRateSettingEdit;
